import {useScrollToComments} from '../../../../comments/use-scroll-to-comments'
import {useAllThreads} from '../../../../../stores/layout-selectors'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {MiniStatusSkeletonItem} from './MiniMergeStatusLoading'

export function CommentsMiniStatus() {
  const scrollToComments = useScrollToComments()
  const threads = useAllThreads()
  const totalThreads = threads.length
  const resolvedThreads = threads.filter(thread => thread.isResolved).length
  const iconType = totalThreads === 0 ? 'neutral' : resolvedThreads === totalThreads ? 'success' : 'warning'

  return (
    <MiniMergeStatusItem aria-label="Resolved comments">
      <MiniMergeStatusItem.LabelRow>
        <MiniMergeStatusItem.Label icon={iconType} successful={resolvedThreads} total={totalThreads}>
          Resolved comments
        </MiniMergeStatusItem.Label>
        <MiniMergeStatusItem.Action aria-label="View comments" onClick={scrollToComments} />
      </MiniMergeStatusItem.LabelRow>
      <MiniMergeStatusItem.Progress
        aria-label={`${resolvedThreads} of ${totalThreads} resolved comments`}
        successful={resolvedThreads}
        total={totalThreads}
      />
    </MiniMergeStatusItem>
  )
}

export function CommentsMiniStatusBoundary({children}: {children: React.ReactNode}) {
  const scrollToComments = useScrollToComments()

  return (
    <ErrorBoundary boundaryName="CommentsMiniStatusBoundary" fallback={null}>
      <Suspense fallback={<MiniStatusSkeletonItem text="Resolved comments" action={scrollToComments} />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  )
}
